import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getUserSignature(userId) {
  return fetchQuery("GetUserBase64Signature", { userId: userId});
}
